import { Toaster as Sonner } from 'sonner';

/**
 * Toast host (DESIGN_SYSTEM §4): bottom-right, alert look — tinted fill and tone icon per type,
 * 600 title, muted description, `--shadow-2`. Colours come from the design tokens, so light/dark
 * follows the `.dark` class like the rest of the app. Durations live in `lib/toast.ts`.
 */
function Toaster() {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            '!items-start !gap-3 !rounded-lg !border !px-4 !py-3 !text-foreground !shadow-popover !font-sans !text-body',
          title: '!text-body-strong',
          description: '!text-muted-foreground !text-body',
          icon: '!mt-0.5',
          actionButton:
            '!h-control-sm !rounded-md !bg-primary !px-3 !font-semibold !text-primary-foreground',
          cancelButton: '!h-control-sm !rounded-md !bg-surface-muted !px-3 !text-foreground',
          closeButton: '!border-border !bg-surface !text-muted-foreground hover:!bg-surface-muted',
          // Fill per type (not on `toast`, where it would out-rank the tints by CSS order).
          default: '!border-border !bg-surface',
          loading: '!border-border !bg-surface',
          success: '!border-transparent !bg-success-soft [&_[data-icon]]:!text-success',
          error: '!border-transparent !bg-danger-soft [&_[data-icon]]:!text-danger',
          warning: '!border-transparent !bg-warning-soft [&_[data-icon]]:!text-warning',
          info: '!border-transparent !bg-info-soft [&_[data-icon]]:!text-info',
        },
      }}
    />
  );
}

export { Toaster };
